import { createContext, useContext, useEffect, useState } from "react";

const DropdownGlobalDataContext = createContext();
export const useDropdownGlobalData = () => useContext(DropdownGlobalDataContext);

export const DropdownProvider = ({ children }) => {
    const [dropdownDataContext, setdropdownDataContext] = useState([]);
    const [childDropdownIdWP, setChildDropdownIdWP] = useState(null);
    const [parentValueWP, setParentValueWP] = useState(null);
    const [depToUpdateWP, setDepToUpdateWP] = useState(null);

    const updatedropdownDataContext = (data) => {
        setdropdownDataContext((prevData) => {
            const index = prevData.findIndex((item) => item.dropdownId === data.dropdownId);

            if (index !== -1) {
                const updatedData = [...prevData];
                updatedData[index] = data;
                return updatedData;
            } else {
                return [...prevData, data];
            }
        });
    };

    const updateWPSelectionContext = (childId , parentValues , dependencies)=>{
        setChildDropdownIdWP(childId);
        setParentValueWP(parentValues);
        setDepToUpdateWP(dependencies);
    }
  


    return (
        <DropdownGlobalDataContext.Provider value={{ dropdownDataContext, updatedropdownDataContext , childDropdownIdWP , parentValueWP , depToUpdateWP , updateWPSelectionContext }}>
            {children}
        </DropdownGlobalDataContext.Provider>
    );
};
